import { modalAction } from './modules/modalAction';
import { slider } from './modules/slider';
slider();
modalAction();
